import request from '@/utils/request';

// GraphQL
export async function graphQlAll(params) {
  return request.post('/api/graphql/all', {
    ...params,
  });
}
